import ForgotPasswordContent from "src/components/Auth/ForgotPasswordContent";

const SubmitEmail = () => {
  return <ForgotPasswordContent />;
};

export default SubmitEmail;
